import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const TrackingPage = () => {
  const [applicationId, setApplicationId] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const navigate = useNavigate();

  const handleTrackById = () => {
    if (applicationId.trim()) {
      navigate(`/tracking-details?applicationid=${applicationId}`);
    }
  };

  const sendOtp = async () => {
    try {
      const response = await axios.post('/api/send-otp', { phoneNumber });
      if (response.data.success) {
        setOtpSent(true);
        alert('OTP sent successfully!');
      } else {
        alert('Failed to send OTP');
      }
    } catch (error) {
      console.error('Error sending OTP:', error);
      alert('Error sending OTP');
    }
  };

  const verifyOtp = async () => {
    try {
      const response = await axios.post('/api/verify-otp', { phoneNumber, otp });
      if (response.data.success) {
        navigate(`/tracking-details?applicationid=${response.data.applicationId}`);
      } else {
        alert('Invalid OTP');
      }
    } catch (error) {
      console.error('Error verifying OTP:', error);
      alert('Error verifying OTP');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white p-8 rounded-2xl shadow-xl w-full max-w-md border border-gray-300">
        <h2 className="text-xl md:text-2xl font-bold text-center text-gray-700 mb-6">Track Your Application</h2>
        
        <div className="mb-6">
          <input
            type="text"
            placeholder="Enter Application ID"
            value={applicationId}
            onChange={(e) => setApplicationId(e.target.value)}
            className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button onClick={handleTrackById} className="w-full mt-3 bg-blue-600 text-white p-3 rounded-xl font-semibold hover:bg-blue-700 transition">
            Track by Application ID
          </button>
        </div>
        
        {/* <hr className="my-6" /> */}

        {/* <div className="mb-6">
          <input
            type="text"
            placeholder="Enter Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button onClick={sendOtp} className="w-full mt-3 bg-green-600 text-white p-3 rounded-xl font-semibold hover:bg-green-700 transition">
            Send OTP
          </button>
        </div> */}

        {otpSent && (
          <div className="mb-6">
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="w-full p-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button onClick={verifyOtp} className="w-full mt-3 bg-purple-600 text-white p-3 rounded-xl font-semibold hover:bg-purple-700 transition">
              Verify OTP & Track
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackingPage;